"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@mui/material/styles");
var DescriptionWrapper = (0, styles_1.styled)('div')(function (_a) {
    var theme = _a.theme;
    return (__assign(__assign({}, theme.typography.body1), { color: 'inherit', margin: theme.spacing(2, 0) }));
});
exports.default = DescriptionWrapper;
